import { createElementBlock as e, openBlock as o, createElementVNode as l } from "vue";
import t from "./index289.js";
const c = {}, n = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 60 60"
};
function r(s, a, m, f, i, p) {
  return o(), e("svg", n, a[0] || (a[0] = [
    l("g", {
      fill: "none",
      "fill-rule": "evenodd"
    }, [
      l("path", {
        fill: "#FFF3AB",
        d: "M39 26.987c0-4.415-3.566-7.994-7.965-7.994h-.07c-4.398 0-7.965 3.58-7.965 7.994"
      }),
      l("path", {
        fill: "#000",
        "fill-rule": "nonzero",
        d: "M29 37.75c.647 0 1.18.492 1.244 1.122l.006.128v7a5.25 5.25 0 0 1-10.496.216L19.75 46v-7a1.25 1.25 0 0 1 2.494-.128l.006.128v7a2.75 2.75 0 0 0 5.495.168L27.75 46v-7c0-.69.56-1.25 1.25-1.25Zm4.527.093a1.25 1.25 0 0 1 1.576.568l.054.116 3.274 8.004 2.894-7.958a1.25 1.25 0 0 1 1.48-.785l.122.037c.608.221.94.866.785 1.48l-.037.122-4 11c-.375 1.031-1.78 1.1-2.275.168l-.057-.122-4.5-11a1.25 1.25 0 0 1 .684-1.63Zm-2.492-20.1c5.09 0 9.215 4.14 9.215 9.244a1.25 1.25 0 0 1-2.5 0c0-3.646-2.881-6.615-6.48-6.74l-.304-.004c-3.708 0-6.716 3.019-6.716 6.744a1.25 1.25 0 1 1-2.5 0c0-5.015 3.982-9.098 8.949-9.24l.336-.004ZM18.2 25.737a1.25 1.25 0 0 1 .128 2.494l-.128.006H15a1.25 1.25 0 0 1-.128-2.494l.128-.006h3.2Zm28.8 0a1.25 1.25 0 0 1 .128 2.494l-.128.006h-3.2a1.25 1.25 0 0 1-.128-2.494l.128-.006H47ZM20.582 14.821l.101.09 1.6 1.6a1.25 1.25 0 0 1-1.665 1.86l-.102-.092-1.6-1.599a1.25 1.25 0 0 1 1.666-1.86Zm22.502.091a1.25 1.25 0 0 1 .09 1.667l-.09.101-1.6 1.599a1.25 1.25 0 0 1-1.858-1.667l.091-.101 1.599-1.599a1.25 1.25 0 0 1 1.768 0ZM31 9.75c.647 0 1.18.492 1.244 1.122l.006.128v3.197a1.25 1.25 0 0 1-2.494.128l-.006-.128V11c0-.69.56-1.25 1.25-1.25Zm12.8 22.382a1.25 1.25 0 0 1 .128 2.493l-.128.007H18.2a1.25 1.25 0 0 1-.128-2.494l.128-.006h25.6Z"
      })
    ], -1)
  ]));
}
const Z = /* @__PURE__ */ t(c, [["render", r]]);
export {
  Z as default
};
